import { Component, OnInit, Input, EventEmitter, Output, OnChanges } from '@angular/core';
import type { SimpleChanges } from '@angular/core';
import { QuestionViewModel } from 'src/app/shared/models/questionview.model';
import { RE2JS } from 're2js';

@Component({
  selector: 'app-inputType-text',
  templateUrl: './inputType-text.component.html',
  styleUrls: ['./inputType-text.component.scss']
,  standalone: false
})
export class InputTypeTextComponent implements OnInit, OnChanges {

  @Input() question: QuestionViewModel;
  @Input() questionIndex: number;
  @Input() totalQuestion: number;
  @Input() showName?: boolean=true;
  @Input() IsReadOnly?:boolean=false;
  @Input() textRows?:number=5;
  @Input() IsConsentScreen?:boolean=false;
  minLength: number = 0;
  maxLength: number = 4000;
  errormgvisible: boolean = false;
  validationerrormessage: string[] = [];
  errorMessages: string[] = [];
  isConditionIsTrue: boolean;
  validationPattern: string = "[A-Z0-9!@#$&%()\\-`.+,/\"^a-z ]{1,999}"
  checkallvalidations: string = ""; 
  alphabetsPattern_Js: string = "^[A-Za-z ]+$";// "[a-zA-Z]";
  numberPattern_Js: string = "^[0-9]+$";
  specialCharactersPattern: string = "!@#$&()\\-`.+,/\"*$%_^";
  specialCharactersPattern_Js: string = "[!@#$&()\\-`.+,/\"*$%_^]*$";
  isNumberValidation: boolean = false;
  isCharactersValidation: boolean = false;
  isSpecialCharactersValidation: boolean = false;
  excludeCharacters: string;
  isExcludeCharactersValidation: boolean = false;
  userTyping: boolean = false;
  // controlColor: string;
  // @Input() foregroundcolor: string;
  // @Input() backgroundcolor: string;
  // @Input() theme: string;
  // @Input() controlBGColor: string;
  // @Input() controlBorder: string;
  // @Input() TextColor: string;

  @Output() childQuestion: EventEmitter<QuestionViewModel> = new EventEmitter<QuestionViewModel>();
  @Output() inputChange: EventEmitter<Boolean> = new EventEmitter<Boolean>();
  //new: string = ".{5,10}";

  ngOnChanges(changes: SimpleChanges) {
    if (changes['question'] && changes['question'].currentValue) {
      const currentQuestion = changes['question'].currentValue;
      this.question = { ...currentQuestion }; // Create a new reference to trigger change detection
      this.checkvalidations(this.question["responseText"]);
      this.childQuestion.emit(this.question);    
    }       
  }

  ngOnInit() {
    this.question["IsValid"] = true;
    this.errorMessages = [];
    this.errormgvisible = false;
    if (this.question.isQuestionRequired == "Y" ) {
      this.isConditionIsTrue = true;
    }
    else {
      this.isConditionIsTrue = false;
    }
    
  }

  ngDoCheck() {
    if (this.question.errorMessage && !this.userTyping) {
      this.checkvalidations(this.question["responseText"]);
      this.CheckRequiredValidation(this.question["responseText"]);
      this.errormgvisible = this.errorMessages.length > 0;
    }
  }
  onFocus(event) {
    this.errormgvisible = false; this.userTyping = true;
  }

  onBlur(event) {
    const newValue = event.target.value;
    this.question["responseText"] = newValue;
    this.question.errorMessage = null;
    this.errorMessages = [];
    this.checkvalidations(newValue);
    this.errormgvisible = this.errorMessages.length > 0;
    this.question["IsValid"] = !this.errormgvisible;
    this.childQuestion.emit(this.question);
    this.inputChange.emit(true);
    this.userTyping = false;
  }

  onSelect(event) {  
    this.userTyping = true;
    const newValue = event.target.value;
    this.question["responseText"] = newValue;
    this.errorMessages = [];
    this.errormgvisible = false;
    
    // Check for restricted characters first
    if (newValue && newValue.length > 0) {
      this.CheckRestrictedCharacters(newValue);
      if (this.errorMessages.length > 0) {
        this.errormgvisible = true;
        this.question["IsValid"] = false;
        this.childQuestion.emit(this.question);
        this.inputChange.emit(true);
        return;
      }
    }
    
    this.inputChange.emit(true);
  }
  checkvalidations(newValue: any)
  {  
    this.errorMessages = [];
    this.errormgvisible = false;
    this.question["IsValid"] = true;

    if(newValue != undefined && newValue != null) {
      // Check for restricted characters first
      if(newValue && newValue.length > 0) {
        this.CheckRestrictedCharacters(newValue);
        if (this.errorMessages.length > 0) {
          this.errormgvisible = true;
          this.question["IsValid"] = false;
          this.childQuestion.emit(this.question);
          return;
        }
      }
      
      this.CheckRequiredValidation(newValue);
      if(newValue && newValue.length > 0) {
        this.checkMaxLengthValidation(newValue);
        this.CheckRangeValidation(newValue);
      }
      // Don't return early, let all validations run
  
      
      //Regular Validation
      this.CheckPatternValidation(newValue);
      if (this.errorMessages.length > 0) {
        this.errormgvisible = true;
        this.question["IsValid"] = false;
        this.childQuestion.emit(this.question);
        return;
      }
  
      if (this.errorMessages.length == 0) {
        this.errormgvisible = false;
        this.question["IsValid"] = true;
      }
      
      this.childQuestion.emit(this.question);
    } 
    

  }
  CheckRequiredValidation(textResp: string) {
    const errorMsg = "Input is mandatory";
    if (
      this.question.isQuestionRequired === "Y" &&
      (!textResp || textResp.trim().length === 0)
    ) {
      // Use a Set to avoid duplicates, or check before adding
      if (this.errorMessages.indexOf(errorMsg) === -1) {
        this.errorMessages.push(errorMsg);
      }
      this.errormgvisible = true;
      this.question["IsValid"] = false;
      this.childQuestion.emit(this.question);
      return;
    }
  }
  checkMaxLengthValidation(textResp: string) {

    if (this.question.maxLength!=null && textResp.trim().length > this.question.maxLength)
     { this.errorMessages.push("Length cannot exceed "+ this.question.maxLength +" characters");
      this.errormgvisible = true;
      this.question["IsValid"] = false;
      this.childQuestion.emit(this.question);
      return;
  }
  }

  CheckRangeValidation(textResp: string) {
    let rangeValidators = this.question.validationDetails.filter(i => i.validationType == "1");
    if (rangeValidators.length > 0) {
      if (isNaN(Number(textResp))) {
        rangeValidators.forEach(validation => {
          if (textResp.length > validation.maxRange || textResp.length < validation.minRange) {
            let found = this.errorMessages.find(x=> x == validation.errorMessage);
            if(found == null){
              this.errorMessages.push(validation.errorMessage);
            }
            //this.errorMessages.push(validation.errorMessage);
          }
        });
      }
      else {
        rangeValidators.forEach(validation => {
          if (Number(textResp) > validation.maxRange || Number(textResp) < validation.minRange) {
            let found = this.errorMessages.find(x=> x == validation.errorMessage);
            if(found == null){
              this.errorMessages.push(validation.errorMessage);
            }
            //this.errorMessages.push(validation.errorMessage);
          }
        });
      }
    }
  }

  CheckPatternValidation(textResp: string) {
    if(textResp && textResp.length>0 )
    {


    let regularExpValidators = this.question.validationDetails.filter(i => i.validationType == "2");
    let regexMessage: string[] = [];
    let validTextCont: number = 0;
    if (regularExpValidators.length > 0) {
     
      regularExpValidators.forEach(validtn => {
        const pattern = this.GetPattern(validtn);
        if (pattern.length > 0) {
          try {
            //SECURITY FIX: Use RE2JS instead of native RegExp to prevent ReDoS attacks
            const isMatch = RE2JS.matches(pattern, textResp);
            if (!isMatch || this.CheckExcludedCharacters(textResp, validtn.excludeCharacters)) {
              regexMessage.push(validtn.errorMessage)
            }
            else {
              validTextCont = validTextCont + 1;
            }
          } catch (error) {
            console.error('Regex validation error:', error);
            regexMessage.push('Invalid validation pattern configuration');
          }
        }
      });
      if (regexMessage.length > 0) {
        regexMessage.forEach(errMsg => {         
          let found = this.errorMessages.find(x=> x == errMsg);
          if(found == null){
            this.errorMessages.push(errMsg);
          }
        });
      }
    }
  }
  }

  GetPattern(validObject: any): string {
    let newPattern = "";
    if (validObject.isNumericAllowed === true) {
      newPattern += this.numberPattern_Js;
    }
    if (validObject.isCharacterAllowed === true) {
      if (newPattern == "")
        newPattern = newPattern + this.alphabetsPattern_Js;
      else
        newPattern = newPattern + "|" + this.alphabetsPattern_Js;
    }

    if (validObject.isSpecialCharacterAllowed === true) {
      if (newPattern == "")
        newPattern = newPattern + this.specialCharactersPattern_Js;
      else
        newPattern = newPattern + "|" + this.specialCharactersPattern_Js;
    }

    if(validObject.regularExpression != "")
    {
      if (newPattern == "")
        newPattern = newPattern + validObject.regularExpression;
      else
        newPattern = newPattern + "|" + validObject.regularExpression;
    }

    return newPattern;
  }

  CheckExcludedCharacters(textResp: string, excludedCharacters: string): boolean {
    let isCharExists: boolean = false;
    //exclude characters functionality
    if (excludedCharacters != null && excludedCharacters != "") {
      let loop = "continue";
      let arraylist = excludedCharacters.split(",");
      arraylist.forEach((obj, index) => {
        if (loop === "continue") {
          if (textResp.includes(obj) == true) {
            loop = "break";
          }
        }
      });
      if (loop === "break") {
        isCharExists = true;
      }
      else {
        isCharExists = false;
      }
    }
    return isCharExists;
  }

  CheckRestrictedCharacters(textResp: string): void {
    const restrictedChars = ['<', '>', '{', '}', '#', '*', '`'];
    const foundChars: string[] = [];
    
    restrictedChars.forEach(char => {
      if (textResp.includes(char)) {
        foundChars.push(char);
      }
    });
    
    if (foundChars.length > 0) {
      const errorMsg = "These characters are not allowed: < > { } # * `";
      if (this.errorMessages.indexOf(errorMsg) === -1) {
        this.errorMessages.push(errorMsg);
      }
      this.errormgvisible = true;
      this.question["IsValid"] = false;
    }
  }
}
